import { render, staticRenderFns } from "./LogoYoutubeSvg.vue?vue&type=template&id=7382994e"
import script from "./LogoYoutubeSvg.vue?vue&type=script&lang=js"
export * from "./LogoYoutubeSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports